import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ShieldCheck, ArrowRight, UserPlus, LogIn, BellRing, Bot } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface AuthGateModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: "proceso" | "chatbot";
  metadata?: {
    radicado?: string;
    despacho?: string;
  };
}

export const AuthGateModal: React.FC<AuthGateModalProps> = ({ isOpen, onClose, type, metadata }) => {
  const navigate = useNavigate();

  const handleAction = (route: "/signup" | "/login") => {
    onClose();
    navigate(route);
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl shadow-2xl">
        <DialogHeader className="text-center sm:text-left">
          <div className="mx-auto sm:mx-0 w-12 h-12 rounded-xl bg-blue-50 dark:bg-blue-950 flex items-center justify-center text-blue-600 mb-3 border border-blue-200/60 dark:border-blue-900">
            {type === "proceso" ? <BellRing className="w-6 h-6" /> : <Bot className="w-6 h-6" />}
          </div>
          <DialogTitle className="text-xl font-bold text-slate-900 dark:text-white">
            {type === "proceso" ? "Vigila este Proceso 24/7" : "Continúa tus Consultas con SARAI"}
          </DialogTitle>
          <DialogDescription className="text-sm text-slate-600 dark:text-slate-300 mt-1.5 leading-relaxed">
            {type === "proceso" ? (
              <>
                Para registrar el radicado <strong className="text-blue-600 dark:text-blue-400 font-mono">{metadata?.radicado || "seleccionado"}</strong> y recibir alertas tempranas por correo de cada auto y estado fijado por el juzgado, inicia sesión o crea tu cuenta gratuita.
              </>
            ) : (
              <>
                Has alcanzado el límite de consultas de demostración. Crea tu cuenta gratuita para continuar el análisis de este caso, adjuntar contratos o demandas y consultar jurisprudencia sin restricciones.
              </>
            )}
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-2.5 mt-5">
          <Button
            onClick={() => handleAction("/signup")}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold h-11 rounded-xl shadow-md hover:shadow-lg transition-all flex items-center justify-center gap-2"
          >
            <UserPlus className="w-4 h-4" />
            <span>Crear Cuenta Gratuita</span>
            <ArrowRight className="w-4 h-4 ml-auto" />
          </Button>

          <Button
            variant="outline"
            onClick={() => handleAction("/login")}
            className="w-full border-slate-200 dark:border-slate-800 hover:bg-slate-50 dark:hover:bg-slate-800 font-semibold h-11 rounded-xl flex items-center justify-center gap-2"
          >
            <LogIn className="w-4 h-4" />
            <span>Ya tengo cuenta • Iniciar Sesión</span>
          </Button>
        </div>

        <div className="mt-4 pt-3 border-t border-slate-100 dark:border-slate-800 text-center">
          <p className="text-[11px] text-slate-400 flex items-center justify-center gap-1.5">
            <ShieldCheck className="w-3.5 h-3.5 text-emerald-500" />
            Sin tarjeta de crédito requerida • Acceso inmediato a la suite legal
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

